import React, { Component } from "react"
import Kalend, { CalendarView } from "kalend"
import "kalend/dist/styles/index.css" // import styles
import "./CalendarComponent.css"

import { db } from "../../firebase/firebase_config"
import { collection, doc, getDocs, orderBy, query } from "firebase/firestore"
// const events = [
// 	{
// 		id: 1,
// 		startAt: "2022-09-21T18:00:00.000Z",
// 		endAt: "2022-09-21T19:00:00.000Z",
// 		timezoneStartAt: "Europe/Berlin", // optional
// 		summary: "test",
// 		color: "blue",
// 		calendarID: "work",
// 	},
// 	{
// 		id: 2,
// 		startAt: "2022-09-21T18:00:00.000Z",
// 		endAt: "2022-09-21T19:00:00.000Z",
// 		timezoneStartAt: "Europe/Berlin", // optional
// 		summary: "test",
// 		color: "blue",
// 		calendarID: "work",
// 	},
// ]
export class CalendarComponent extends Component {
	constructor() {
		super()
		this.state = {
			loading: true,
			events: [],
		}
	}
	async componentDidMount() {
		const events_ret = await this.getTournamentsData()
		this.setState({ loading: false, events: events_ret })
	}

	getTournamentsData = async () => {
		let tournamentsList = []
		try {
			const tournamentCollection = collection(db, "Tournaments")
			const q = query(tournamentCollection, orderBy("START_DATE", "asc"))
			await getDocs(q).then((snapshot) => {
				snapshot.forEach((doc) => {
					const ret_data = { ...doc.data() }
					const start_date = new Date(
						ret_data.START_DATE.seconds * 1000 +
							ret_data.START_DATE.nanoseconds / 1000000
					)
					const end_date = new Date(
						ret_data.END_DATE.seconds * 1000 +
							ret_data.END_DATE.nanoseconds / 1000000
					)
					tournamentsList.push({
						startAt: start_date.toISOString(),
						endAt: end_date.toISOString(),
						//timezoneStartAt: ret_data.COUNTRY,
						//summary: ret_data.DESCRIPTION,
						summary: ret_data.NAME,
						id: doc.id,
						name: ret_data.NAME,
						color: "lightblue",
						calendarID: "work",
					})
				})
			})
		} catch (error) {
			console.log("Error fetching Tournaments firestore data: " + error.message)
		}
		//console.log(tournamentsList)
		return tournamentsList
	}

	onEventClick() {}

	render() {
		return (
			<div className={"Calendar__wrapper"}>
				{!this.state.loading && (
					<Kalend
						colors={{
							light: {
								primaryColor: "blue",
							},
							dark: {
								primaryColor: "orange",
							},
						}}
						onEventClick={this.onEventClick}
						//onNewEventClick={onNewEventClick}
						events={this.state.events}
						initialDate={new Date().toISOString()}
						hourHeight={40}
						initialView={CalendarView.AGENDA}
						disabledViews={[CalendarView.THREE_DAYS, CalendarView.DAY]}
						//onSelectView={onSelectView}
						//selectedView={CalendarView.MONTH}
						//onPageChange={onPageChange}
						timeFormat={"24"}
						//timezone={"Europe/Berlin"}
						weekDayStart={"Monday"}
						calendarIDsHidden={["work"]}
						language={"es"}
					/>
				)}
			</div>
		)
	}
}

export default CalendarComponent
